var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditIcon2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.6889,
    height: 19.2111,
    rx: 2.95556,
    fill: "#261966"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7285 8.51909L11.9809 7.77148L7.05728 12.6951V13.4427H7.80489L12.7285 8.51909ZM13.4761 7.77148L14.2237 7.02387L13.4761 6.27625L12.7285 7.02387L13.4761 7.77148ZM8.24284 14.5H6V12.2571L13.1023 5.15483C13.3088 4.94839 13.6435 4.94839 13.8499 5.15483L15.3452 6.65006C15.5516 6.85651 15.5516 7.19123 15.3452 7.39767L8.24284 14.5Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditIcon2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-icon-2.ff2cb97227adb68ccd1910017d19aba6.svg";